import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";
import { ChakraProvider } from '@chakra-ui/react';
import { Provider as ReduxProvider} from 'react-redux';
import { store } from './Redux/store';
import { PriceContextProvider} from './context/PriceContext'

ReactDOM.render(
  <React.StrictMode>
    <ReduxProvider store={store}>
    <PriceContextProvider>
      <ChakraProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
      </ChakraProvider>
      </PriceContextProvider>
    </ReduxProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
